import { Container } from "reactstrap";
import ProfileEditContain from "../../Components/Recruiter/Profile";
import { Fragment } from "react";
import Breadcrumbs from "../../Components/Common/Breadcrumb";
import { useParams } from "react-router";
import { useEffect } from "react";
const JobCandidateDetailsPage = () => {
  const { cand_id, jobcad_id } = useParams();

  useEffect(() => {


    console.log("hello1", "achana");

  }, []);
  return (
    <Fragment>
      <Breadcrumbs
        title={"Candidates Details"}
        mainTitle={"Candidates Details"}
      />
      <Container fluid={true}>
        <ProfileEditContain />
      </Container>
    </Fragment>
  );
};

export default JobCandidateDetailsPage;
